import { IconButton, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledIconButton = styled(IconButton) `
  [data-icon='falcon'] {
    color: ${(props) => (props.$appearance === 'info' ? themeGet('colors.blue.500') : themeGet('colors.red.500'))};
  }
`;
